import React from 'react';
import Skeleton from 'react-loading-skeleton';

import EFakturaApprovalListSkeleton from '../../components/EFakturaList/EFakturaApprovalListSkeleton';

const MultipleApprovalEFakturaListSkeleton: React.FC = () => {
    return (
        <section className="multi-approval-efaktura sgw-content">
            <div className="multi-approval-efaktura__list--intro">
                <Skeleton className="multi-approval-efaktura__list--intro-title skeleton" width={120} />
                <Skeleton className="multi-approval-efaktura__list--intro-button skeleton" height={28} width={80} />
            </div>
            <EFakturaApprovalListSkeleton count={4} />
        </section>
    );
};

export default MultipleApprovalEFakturaListSkeleton;
